<template>
  <div>
    <div class="filter">
      <el-form
        :inline="true"
        @submit.native.prevent
        :model="filter"
        ref="filterForm"
        label-position="right"
        label-width="90px"
        class="oneline"
        size="small"
      >
        <el-form-item :label="category == 1 ? '发往基地' : '库存基地'">
          <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
        </el-form-item>
        <el-form-item label="钻井" v-if="category == 2">
          <DrillWellSelect
            v-model="filter.drill_well_id"
            :clearable="true"
          ></DrillWellSelect>
        </el-form-item>
        <el-form-item label="成品分类">
          <ProductTemplateSelect
            v-model="filter.product_template_id"
            :category="category"
            :clearable="true"
          ></ProductTemplateSelect>
        </el-form-item>
        <el-form-item label="未使用时长">
          <el-select v-model="filter.not_used_category">
            <el-option key="1" label="从未使用" :value="1"></el-option>
            <el-option key="2" label="超过3个月未使用" :value="90"></el-option>
            <el-option key="3" label="超过6个月未使用" :value="180"></el-option>
            <el-option key="4" label="超过1年未使用" :value="365"></el-option>
          </el-select>
          <!-- <ProductTemplateSelect
            v-model="filter.product_template_id"
            :category="category"
            :clearable="true"
          ></ProductTemplateSelect> -->
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="display: flex; justify-content: end">
      <file-button
        obj="not_used_product"
        :filter="queryData"
        exportBtnName="导出明细"
        :importButton="false"
      ></file-button>
    </div>
    <MyTable
      :items="items.list"
      :category="category"
      v-loading="loading"
    ></MyTable>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData()"
      layout="total, prev, pager, next"
      :total="items.count"
    ></el-pagination>
  </div>
</template>

<script>
import { productStatistics } from '@/service/getData'
import MyTable from './table'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    MyTable,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.category = this.category
      data.is_not_used = true
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        base_id: '',
        drill_well_id: '',
        product_template_id: '',
        not_used_category: 1,
        page: 1,
        size: 10,
        tab: 'not_used_data',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      if (filter.tab == 'not_used_data') {
        this.filter = filter
      }
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.base_id = ''
        this.filter.drill_well_id = ''
        this.filter.product_template_id = ''
        this.filter.not_used_category = 1
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await productStatistics(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>